import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#1b4332",
        color: "#ffffff",
        py: 4,
        px: { xs: 2, md: 6 },
        textAlign: "center",
      }}
    >
      {/* Copyright */}
      <Typography
        variant="body2"
        sx={{
          color: "rgba(255,255,255,0.8)",
          fontSize: "0.9rem",
        }}
      >
        © {new Date().getFullYear()} Tuberway. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
